// CSS
import "@/stylesheets/application.scss";
import "@/stylesheets/normalize.css";
import "@/stylesheets/style.css";
import "@/stylesheets/custom.css";
import "@/stylesheets/style_admission_print.css";
// JS
import "@hotwired/turbo-rails";
import "@/controllers";

document.addEventListener("turbo:frame-missing", (event) => {
  const {
    detail: { response, visit },
  } = event;
  event.preventDefault();
  visit(response.status === 401 ? "/errors/401" : response.url);
});
